import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=b5786bbc&scoped=true&"
import script from "./AppIcon.vue?vue&type=script&lang=ts&"
export * from "./AppIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=b5786bbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5786bbc",
  null
  
)

export default component.exports